<template>
  <div id="Institution">
    <div class="card-wrap pos-c">
      <div class="card">
        <h2>
          <img src="./img/card-title.png" alt="title">
        </h2>
        <div class="content">
          <div class="left">
            <div class="title">港珠澳大桥参建单位名录</div>
            <div class="text">
              <h3>初步设计</h3>
              <span>中交公路规划设计院有限公司（主办人）</span>
              <span>丹麦科威国际咨询公司</span>
              <span>奥雅纳工程顾问</span>
              <span>上海市隧道工程轨道交通设计研究院</span>
              <span>中交第一航务工程勘察设计院有限公司</span>

              <h3>设计及施工咨询</h3>
              <span>上海市政工程设计研究总院（主办人）</span>
              <span>林同棪国际集团</span>
              <span>荷兰隧道工程咨询公司</span>
              <span>广州地铁设计研究院</span>

              <h3>主体工程质量管理顾问</h3>
              <span>莫特麦克唐纳有限公司</span>
              <span>莫特麦克唐纳咨询（北京）有限公司</span>

              <h3>岛隧工程设计施工总承包</h3>
              <span>中国交通建设股份有限公司（总牵头人）</span>
              <span>中交公路规划设计院有限公司</span>
              <span>艾奕康有限公司</span>
              <span>丹麦科威国际咨询公司</span>
              <span>上海城建（集团）公司</span>
              <span>上海市隧道工程轨道交通设计研究院</span>
              <span>中交第四航务工程勘察设计院有限公司</span>

              <h3>岛隧工程监理</h3>
              <span>中铁武汉大桥工程咨询监理有限公司（牽头人）</span>
              <span>广州港工程监管有限公司</span>
              <span>广州市市政工程监理有限公司</span>

              <h3>桥梁工程施工图设计阶段勘察设计（DB01标）</h3>
              <span>中交公路规划设计院有限公司（主办人）</span>
              <span>日本国株式会社长大</span>

              <h3>桥梁工程施工图设计阶段勘察设计（DB02标）</h3>
              <span>中铁大桥勘测设计院有限公司（主办人）</span>
              <span>合乐集团有限公司</span>

              <h3>桥梁工程钢箱梁釆购与制造（CB01标）</h3>
              <span>中铁山桥集团有限公司</span>

              <h3>桥梁工程钢箱梁釆购与制造（CB02标）</h3>
              <span>武船重型工程股份有限公司</span>

              <h3>桥架工程土建工程施工（CB03标）</h3>
              <span>中交第一航务工程局有限公司（主办人）</span>
              <span>中交第二公路工程局有限公司</span>

              <h3>桥梁工程土建工程施工（CB04标）</h3>
              <span>广东省长大公路工程有限公司</span>

              <h3>桥梁工程土建工程及组合梁施工（CB05标）</h3>
              <span>中铁大桥局集团有限公司</span>

              <h3>桥面铺装工程施工（CB06标）</h3>
              <span>重庆智翔铺道技术工程有限公司</span>

              <h3>桥面铺装工程施工（CB07标）</h3>
              <span>广东省长大公路工程有限公司</span>

              <h3>桥梁钢箱梁制造监理（SB01标）合同段</h3>
              <span>中国船级社实业公司</span>

              <h3>桥梁钢箱梁制造监理（SB02标）合同段</h3>
              <span>武汉桥梁建筑工程监理有限公司</span>

              <h3>桥梁工程土建工程施工监理（SB03标）</h3>
              <span>铁四院（湖北）工程监理咨询有限公司（主办人）</span>
              <span>广州南华工程管理有限公司</span>

              <h3>桥梁工程土建工程施工监理（SB04标）</h3>
              <span>西安方舟工程咨询有限责任公司（主办人）</span>
              <span>中国船级社实业公司</span>

              <h3>桥梁工程桥面铺装工程施工监理（SB05标）</h3>
              <span>西安方舟工程咨询有限责任公司</span>

              <h3>试验检测中心</h3>
              <span>广东华路交通科技有限公司（主办人）</span>
              <span>江苏省交通科学研究院股份有限公司</span>

              <h3>测量控制中心</h3>
              <span>中铁大桥勘测设计院有限公司</span>

              <h3>桥梁工程钢箱梁、组合梁及索塔钢结构第三方试验检测</h3>
              <span>江苏法尔胜材料分析测试有限公司</span>

              <h3>房建工程施工（CAO1标）</h3>
              <span>湖南建工集团有限公司</span>

              <h3>房建工程施工监理（SA01标）</h3>
              <span>广东重工建设监理有限公司</span>

              <h3>交通工程施工（CAO2标）</h3>
              <span>中国铁建电气化局集团有限公司（牵头人）</span>
              <span>中国铁建电气化局集团第一工程有限公司</span>

              <h3>交通工程施工监理（SA02标）</h3>
              <span>重庆中宇工程咨询监理有限责任公司（牵头人）</span>
              <span>珠海电力工程监理有限责任公司</span>

              <h3>房建工程施工图设计</h3>
              <span>广东省建筑设计研究院</span>

              <h3>桥梁试桩工程施工及试验研究</h3>
              <span>广东省长大公路工程有限公司（主办人）</span>
              <span>交通运输部公路科学研究所</span>

              <h3>主体工程桥梁埋置承台足尺模型工艺实验研究</h3>
              <span>中交第二航务工程局有限公司</span>

              <h3>港珠澳大桥主体工程综合信息系统开发</h3>
              <span>第一阶段广东东方思维科技有限公司</span>
              <span>第二阶段广东同望科技股份有限公司</span>
              <span/>
            </div>
          </div>
          <div class="right">
            <div class="title">港珠澳大桥科研课题/专题研究名录</div>
            <div class="text">
              <h3>课题一:外海厚软基大回淤超长沉管隧道设计与施工关键技术</h3>
              <h3>合同主体单位</h3>
              <span>中交公路规划设计院有限公司</span>
              <h3>课题承担单位</h3>
              <span>东南大学</span>
              <span>长安大学</span>
              <span>同济大学</span>
              <span>株洲时代新材料科技股份有限公司</span>
              <span>中交第一航务工程局有限公司</span>
              <span>上海振华重工（集团）股份有限公司</span>
              <span>中交第四航务工程局有限公司</span>

              <h3>课题二:外海厚软基桥隧转换人工岛设计与施工关键技术</h3>
              <h3>合同主体单位</h3>
              <span>中交第三航务工程局有限公司</span>
              <h3>课题承担单位</h3>
              <span>中交上海三航科学研究院有限公司</span>
              <span>中交第一航务工程局有限公司</span>
              <span>中交第一航务工程物察设计院有限公司</span>
              <span>中交第四航务工程察设计院有限公司</span>
              <span>中交第三航务工程局有限公司</span>

              <h3>课题三:海上装配化桥梁建设关键技术</h3>
              <h3>合同主体单位</h3>
              <span>中交公路规划设计院有限公司</span>
              <h3>课题承担单位</h3>
              <span>中交第二航务工程局有限公司</span>
              <span>广东长大公路工程有限公司</span>
              <span>西南交通大学</span>
              <span>华南理工大学</span>

              <h3>课题四:跨海集群工程混凝土结构120年使用寿命保障关键技术</h3>
              <h3>合同主体单位</h3>
              <span>中交四航工程研究院有限公司</span>
              <h3>课题承担单位</h3>
              <span>清华大学</span>
              <span>同济大学</span>
              <span>中交第四航务工程局有限公司</span>

              <h3>课题五:跨境隧－岛－桥集群工程建设管理、防灾减灾及节能环保关键技术</h3>
              <h3>合同主体单位</h3>
              <span>港珠澳大桥管理局</span>
              <h3>课题承担单位</h3>
              <span>南京大学</span>
              <span>交通运输部规划研究院</span>
              <span>中国科学院水生生物研究所</span>
              <span>中山大学</span>
              <span>招商局重庆交通科研设计院有限公司</span>
              <span>同济大学</span>
              <span>交通运输部公路科学研究所</span>
              <span>中国科学院广州能源研究所</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <guide-button class="btn-lt" @click="$router.push('/Part04/Portrait')">返回</guide-button>
    <guide-button class="btn-rt" @click="$router.push('/TitlePage/05')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'Institution',
}
</script>

<style lang="scss" scoped>
#Institution {
  height: 100%;
  .card {
    width: 13rem;
    height: 7rem;
    padding: 0.01rem;
    background-image: url(./img/card-bg.png);
    background-size: contain;
    background-repeat: no-repeat;
    h2 {
      height: 0.7rem;
      margin: 0.3rem;
      text-align: center;
      & > img {
        height: 100%;
      }
    }
    .content{
      padding: .1rem;
      .left,.right{
        width: 49%;
        float: left;
        margin-left: .5%;
        .title{
          background: #0068B7;
          font-weight: bold;
          color: #fff;
          padding: .2rem;
          font-size: .26rem;
          text-align: center;
        }
        .text{
          padding: 0 .2rem .2rem .2rem;
          margin-top: 0.2rem;
          height: 4rem;
          overflow: auto;
          &::-webkit-scrollbar {
          /*滚动条整体样式*/
            width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 12px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            // background: rgba(0, 0, 0, 0.2);
            background: #7EA6DA;
          }
          &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
          }
          & > h3{
            float: left;
            margin: 0.2rem 0 0.07rem 0;
            font-size: 0.19rem;
            font-weight: bold;
            line-height: 1.2;
            color: #0451A7;
          }
          & > span{
            font-size: .18rem;
            font-weight: 500;
            width: 100%;
            float: left;
            margin: 0.04rem 0;
          }
        }
      }
    }
  }
}
</style>
